module.exports = (__webpack_require__(351725))("./node_modules/router5-transition-path/dist/index.es.js");